// This is a form with a supporting image/text block
import React, { useState, useEffect } from 'react'
import * as Styled from './styles/AdvancedForm.styles'
import { PrismicRichText } from '@prismicio/react'
import { DISPLAY_WIDTH } from '../../util/constants'

const LAYOUT_TYPE = {
  MOBILE: {
    FORM_TOP: 'Form Top->Image Bottom',
    FORM_BOTTOM: 'Image Top->Form Bottom',
  },
  DESKTOP: {
    FORM_LEFT: 'Form Left->Image Right',
    FORM_RIGHT: 'Image Left->Form Right',
  },
}

const AdvancedForm = (data, bottomPaddingAdjustment) => {
  const {
    image: img,
    form_embed_code,
    mobile_layout,
    desktop_layout,
    text_content,
  } = data?.data ?? {}
  const embedCode = form_embed_code?.text

  return (
    <Styled.AdvancedForm>
      <div>
        <Styled.FormContainer
          mobile_layout={mobile_layout}
          desktop_layout={desktop_layout}
          dangerouslySetInnerHTML={{ __html: embedCode }}
        />
        <Styled.TextAndImageContainer
          mobile_layout={mobile_layout}
          desktop_layout={desktop_layout}
        >
          <Styled.UpperContainer>
            {img && img?.url && (
              <picture>
                {img?.thumbnails?.mobile?.url && (
                  <source
                    media={`(max-width: ${DISPLAY_WIDTH.tabletL - 1}px)`}
                    srcSet={img.thumbnails.mobile.url}
                  />
                )}
                <source
                  media={`(min-width: ${DISPLAY_WIDTH.tabletL}px)`}
                  srcSet={img.url}
                />
                <img src={img.url} alt={img.alt} />
              </picture>
            )}
          </Styled.UpperContainer>
          <Styled.LowerContainer>
            <Styled.LowerContainerCopy>
              <PrismicRichText field={text_content?.richText} />
            </Styled.LowerContainerCopy>
          </Styled.LowerContainer>
        </Styled.TextAndImageContainer>
      </div>
    </Styled.AdvancedForm>
  )
}

export default AdvancedForm
